import { Link } from 'react-router-dom';

const Sidebar = ({ className = '' }: { className?: string }) => {
  return (
    <aside className={`w-64 bg-gray-900 p-4 h-full ${className}`}>
      <ul className="space-y-3 mb-10">
        <li className="text-yellow-400 uppercase font-semibold">Dashboard</li>
        <li>
          <Link to="/dashboard" className="text-white hover:underline">Albums</Link>
        </li>
        <li>
          <Link to="/pricing" className="text-white hover:underline">Pricing</Link>
        </li>
      </ul>

      <div className="mt-10">
        <p className="text-yellow-400 uppercase font-semibold mb-2">Your Tools</p>
        <ul className="space-y-2 text-sm">
          <li>
            <Link to="/create-album" className="text-white hover:underline">Create an Album</Link>
          </li>
          <li>
            <Link to="/upload-images" className="text-white hover:underline">Upload Images</Link>
          </li>
          {/* <li>
            <Link to="/share-album" className="text-white hover:underline">Share Album</Link>
          </li> */}
          <li>
            <Link to="/tokens" className="text-white hover:underline">Tokens</Link>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
